import {IHttpService, IPromise} from "angular";
import {
    DuplicateOrdersVettingResponse,
    SequenceDuplicateVettingResponse
} from "../types/DuplicateOrdersVettingResponse";
import {PlaceOrderRequest} from "./models/PlaceOrderRequest";
import {MultiAccountOrderRequest, SingleAccountEquityOrderRequest} from "./models/PlaceMultiAccountOrderRequest";

export class DuplicateOrderService {

    public static id = "duplicateOrderService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    public async validate(portfolioId: number,
                          trades: ReadonlyArray<PlaceOrderRequest>): Promise<DuplicateOrdersVettingResponse> {
        const url = `/tradefloor/api/duplicate-order/${portfolioId}`;
        const response = await this.$http.post<DuplicateOrdersVettingResponse>(url, trades);
        return response.data!;
    }

    public async validateMultiple(request: MultiAccountOrderRequest): Promise<SequenceDuplicateVettingResponse[]> {
        return this.sequenceRun(request.orders ?? [], (o) => {
            if (o && o.portfolioId) { return this.validate( o.portfolioId, [o.placeOrderRequest]); }
        });
    }

    public sequenceRun<T>(array: ReadonlyArray<T>, fn: (data: T) => any) {
        const promises = array.map((item) => fn(item));
        const mapped = promises.map((p, index) => this.toResult(p, array[index]));
        return Promise.all(mapped);
    }

    private async toResult<T>(p: IPromise<any>, item: T): Promise<any> {
        try {
            const resp = await p;
            return {success: true, request: item, result: resp};
        } catch (error) {
            return {success: false, request: item, result: error};
        }
    }
}
